import React from "react";
import ReactDOM from "react-dom";

import ActionItemDetailsDiv from "./actionItemDetailDiv";
import ListTakeawaysNotes from "./listTakeawaysNotes";
import MeetingTakeawaySection from "./meetingTakeawaySection";
import ListenerComponent from './listenerComponent';

// List Topics and Takeaways
class ListTopicDetails extends ListenerComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      meeting: this.props.meeting,
      topics: this.props.meeting_topics,
      takeaways: this.props.meeting_takes,
      hoverStickEn: false,
      discussTopic: false,
      editTopicDescEdit: false,
      macClass: "",
      resizeClass: ""
    };
    this.initSortable = this.initSortable.bind(this);
    this.handleSortableUpdate = this.handleSortableUpdate.bind(this);
    this.handleSortableUpdateNonTake = this.handleSortableUpdateNonTake.bind(
      this
    );
    this.enableSortable = this.enableSortable.bind(this);
    this.disableSortable = this.disableSortable.bind(this);
    this.hideShowBox = this.hideShowBox.bind(this);
    this.showBox = this.showBox.bind(this);
    this.showHoverStick = this.showHoverStick.bind(this);
    this.hideHoverStick = this.hideHoverStick.bind(this);
    this.disableHoverStick = this.disableHoverStick.bind(this);
    this.stickTopicToDiscuss = this.stickTopicToDiscuss.bind(this);
    this.disableTopicText = this.disableTopicText.bind(this);
  }

  componentDidMount() {
    this.takeCompObj = {};
    this.initSortable();

    $(document).on(
      "mouseover",
      ".meetingTopicTakeDetails.hoverenableDiv",
      function () {
        $(this)
          .find(".takeawayHead.placeholderText textarea")
          .attr("placeholder", "");
      }
    );
    $(document).on(
      "mouseout",
      ".meetingTopicTakeDetails.hoverenableDiv",
      function () {
        $(this)
          .find(".takeawayHead.placeholderText textarea")
          .attr("placeholder", "");
      }
    );
    if (typeof this.props.meeting_topics !== "undefined" && this.props.meeting_topics.length > 0) {
      if (typeof (DD_RUM) !== 'undefined' && typeof (DD_RUM.addTiming) == 'function')
        DD_RUM.addTiming('Meeting_Topic_Takeaway_Loaded')
    }
    window.addEventListener('pushState', this.handleGlobalStateChange);
  }

  componentWillUnmount() {
    window.removeEventListener('pushState', this.handleGlobalStateChange);
  }

  componentDidUpdate() {
    this.initSortable();
  }

  hideHoverStickOnFocus = (e, _this) => {
    setTimeout(function (clickedValue, _this) {
      if (clickedValue.has('.cke')) {
        _this.setState({
          hoverStickEn: !_this.state.hoverStickEn,
        });
      }
    }, 1000, $(e.target).parents('.meetingTopicTakeDetails'), _this)
  }

  initSortable() {
    const _this = this;
    _this.itemDraggable = false;
    $(ReactDOM.findDOMNode(this)).sortable({
      revert: false,
      helper: (event, ui) => {
        const $clone = $(ui).clone();
        $clone.css('position', 'absolute');
        return $clone.get(0);
      },
      items: "div.sortTopicRelTake",
      update: this.handleSortableUpdate,
      connectWith: ".TopicTakeawayContent",
      containment: ".TopicTakeawayContent",
      handle: ".hoverStickDiv",
      cancel: ":input,button,[contenteditable]",
      tolerance: "pointer", // this is the important bit; a tolerance value of 'pointer' means that as long as the users cursor is over one of the other elements the item can replace its position
      start(event, ui) {
        _this.itemDraggable = true;
      },
      stop(event, ui) {
        _this.itemDraggable = false;
        _this.hideHoverStick();
      }
    });
  }

  sortTopics(sortedIds) {
    const meetingId = this.props.meeting.id;

    $.post(
      `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/sort`,
      { sequence: sortedIds },
      (data, status) => {
        if (status == "success") {
          console.log('Successful sort');
          console.log(data);
        }
      }
    );
  }

  handleSortableUpdate() {
    const newItems = [...this.props.meeting_topics];
    const newLists = [];
    const type = 1;

    const $node = $(ReactDOM.findDOMNode(this));
    let ids = $node.sortable("toArray", { attribute: "data-id" });
    ids.forEach((id, index) => {
      const item = newItems.find((ni) => ni.id === id);
      if (typeof item !== "undefined") {
        item.pos = index;
        newLists.push(item);
      }
    });
    ids = ids.reverse();
    // Let React reorder the DOM
    $node.sortable("cancel");
    this.props.sortItemNotes(type, newLists);
    this.sortTopics(ids);
  }

  handleSortableUpdateNonTake() {
    const newItemsTakes = [...this.state.takeaways];
    const newLists = [];
    const type = 2;

    const $node = $(".NonRelTakeawayParent");
    const ids = $node.sortable("toArray", { attribute: "data-id" });
    ids.forEach((id, index) => {
      const lists = newItemsTakes.find((ni) => ni.id === id);
      lists.pos = index;
      newLists.push(lists);
    });
    // Let React reorder the DOM
    $node.sortable("cancel");
    this.props.sortItemNotes(type, newLists);
    this.sortTopics(ids);
  }

  enableSortable() {
    $(ReactDOM.findDOMNode(this)).sortable("option", "disabled", false);
  }

  disableSortable() {
    $(ReactDOM.findDOMNode(this)).sortable("option", "disabled", true);
  }

  hideShowBox(topicRelId) {
    this.setState({
      _timestamp: new Date().getTime()
    });
  }

  showBox(item) {
    let showBox = false;
    let topicTakeCount = 0;
    if (typeof item.topic_take !== "undefined" && item.topic_take.length > 0) {
      showBox = true;
      topicTakeCount = item.topic_take.length;
    }
    const { meeting } = this.props;
    // show box if keep on typing the data for updating the realtime data.
    if (showBox) {
      if (
        typeof this[`takeCompObj_${item.id}`] !== "undefined" &&
        this[`takeCompObj_${item.id}`]
      ) {
        if (typeof this[`takeCompObj_${item.id}`].showBox !== "undefined") {
          if (this[`takeCompObj_${item.id}`].showBox == true) {
            showBox = false;
          }
        }
      }
    }
    return !showBox ? (
      <MeetingTakeawaySection
        ref={ref => (this[`takeCompObj_${item.id}`] = ref)}
        topicTakeCount={topicTakeCount}
        hideShowBox={this.hideShowBox}
        meetingObj={meeting}
        saveMeetingTakeAway={this.props.saveMeetingTakeAway}
        markTakeawayIgnored={this.props.actions.markTakeawayIgnored}
        inlineDialogCurrentlyOpen={this.props.inlineDialogCurrentlyOpen}
        currentUser={this.props.currentUser}
        topicRelId={item.id}
        saveTags={this.props.saveTags}
        userPermission={this.props.userPermission}
        saveMeetingNullTopicNote={this.props.saveMeetingNullTopicNote}
        mtS3Data={this.props.mtS3Data}
        upload_max_size_configured={this.props.upload_max_size_configured}
        actions={this.props.actions}
        clearGlobalValue={this.props.clearGlobalValue}
        tempVar={this.props.tempVar}
        takeTopicId={this.props.takeTopicId}
        clearGlobalValueBta={this.props.clearGlobalValueBta}
        resetTopicTag={this.props.resetTopicTag}
      />
    ) : (
      ""
    );
  }

  showHoverStick(e, id) {
    const currentTopic = this.state.hoverStickEn;
    if (currentTopic != id) {
      const _this = this;
      if (this.itemDraggable) return;
      if ($(e.target).parents('.meetingTopicTakeDetails').has('.cke').length > 0) {
        _this.setState({
          hoverStickEn: !_this.state.hoverStickEn,
          editTopicDescEdit: _this.state.editTopicDescEdit
        });
      } else {
        _this.setState({
          hoverStickEn: id,
          editTopicDescEdit: this.state.editTopicDescEdit
        });
      }

    }
  }

  hideHoverStick() {
    if (this.itemDraggable) return;
    this.setState({
      hoverStickEn: !this.state.hoverStickEn,
      editTopicDescEdit: this.state.editTopicDescEdit
    });
  }

  disableHoverStick(id) {
    this.setState({
      editTopicDescEdit: id
    });
  }

  stickTopicToDiscuss(e, topic_id, discusstopic, description) {
    const { meeting } = this.props;
    const { currentUser } = this.props;
    const { actions } = this.props;
    if (
      (meeting.owner == currentUser.id && description !== "") ||
      (meeting.type == 1 && description !== "")
    ) {
      let value = false;
      if (topic_id == discusstopic) {
        value = false;
      } else {
        value = topic_id;
      }
      create_topic("meet", {
        action: "discuss_topic",
        type: "topic",
        data: { id: topic_id, value },
        topicId: topic_id
      });
      actions.MeetingTopicToDiscuss(topic_id, value);
      $.post(
        `${wbConfig.baseUrl}/meeting/updateTopicToDiscuss`,
        { id: meeting.id, topic_discuss: topic_id },
        (data, status) => {
          if (status == "ok") {
          }
        }
      );
    }
  }

  disableTopicText(id) {
    if (this.state.editTopicDescEdit == id) {
      this.setState({
        editTopicDescEdit: false
      });
    }
    this.disableHoverStick(false);
  }

  render() {
    const { meeting } = this.props;
    const meetingId = meeting.id;
    const { meeting_topics } = this.props;
    const { meeting_takes } = this.props;
    const color = "#FFF";
    const { currentUser } = this.props;
    const lengthTopicOfArr = Object.keys(meeting_topics).length;
    const lengthTakeOfArr = Object.keys(meeting_takes).length;
    let divEnabled = false;
    if (lengthTopicOfArr == 0 && lengthTakeOfArr == 0) {
      divEnabled = true;
    } else if (lengthTopicOfArr < 5 && lengthTopicOfArr > 0) {
      divEnabled = true;
    } else if (lengthTakeOfArr < 5 && lengthTakeOfArr > 0) {
      divEnabled = true;
    }

    const { sortTakeNotes } = this.props;
    const headRowCls = "topicHead";
    const takeSmartWoboId = this.props?.takeSmartWoboId || null

    return (
      <section
        className="emptySectionTopTake displayTable"
        style={{ width: "100%", paddingBottom: "10px" }}
      >
        {typeof meeting_topics !== "undefined" && meeting_topics.length > 0
          ? meeting_topics.map((item, index) =>
            ((item.access == 1 && meeting.type == 1) ||
              (item.access != 1 &&
                currentUser.id == item.added_by &&
                meeting.type == 1) ||
              meeting.type != 1) &&
              (item.description !== "" ||
                (typeof item.topic_take !== "undefined" &&
                  item.topic_take.length > 0)) ? (
              <div
                className={`meetingTopicTakeDetails notEmptyDiv sortTopicRelTake displayTable dragRows_${item.id
                  } ${meeting.status == 1 ? "hoverenableDiv" : ""}`}
                data-pos={item.pos}
                data-itemss={item.access}
                data-type={meeting.type}
                data-cur={currentUser.id}
                data-owner={item.added_by}
                data-id={item.id}
                key={item.id}
                style={{
                  paddingBottom: "0px",
                  overflow: "visible",
                  borderBottom: "2px solid ##ECEFF1",
                  tableLayout: "fixed",
                  backgroundColor:
                    item.id == item.topic_to_discuss ? "#F5F9FA" : ""
                }}
                onMouseEnter={!this.state.isSomethingPending ? e => this.showHoverStick(e, item.id) : null}
                onMouseLeave={!this.state.isSomethingPending ? () => this.hideHoverStick() : null}
                onClick={!this.state.isSomethingPending ? (e, state) => this.hideHoverStickOnFocus(e, this) : null}
              >
                {this.state.hoverStickEn == item.id ||
                  meeting.topic_discuss == item.id ? (
                  <div
                    className={
                      this.state.hoverStickEn != item.id
                        ? "hoverStickDiv displayCell hoverStickNoDrag"
                        : "hoverStickDiv displayCell hoverStick"
                    }
                    onClick={e =>
                      this.stickTopicToDiscuss(
                        e,
                        item.id,
                        item.topic_to_discuss,
                        item.description
                      )
                    }
                  />
                ) : (
                  <div className="hoverStickDiv displayCell" />
                )}
                <div
                  className={`displayCell ${headRowCls} ${this.state.macClass} ${this.state.resizeClass}`}
                  style={{
                    paddingBottom: "2px",
                    borderRight: "5px solid #ECEFF1",
                    verticalAlign: "top"
                  }}
                >
                  <div className="firstDivtopic ">
                    <div
                      className="wb-table meeting_topic_sortable "
                      data-mid={meetingId}
                      data-type="topic"
                    >
                      <ActionItemDetailsDiv
                        key={`action_item_detials_div_${item.id}`}
                        meeting={meeting}
                        topics={item}
                        refreshLegacyData={this.props.refreshLegacyData}
                        editTopicArea={this.props.editTopicArea}
                        deleteTopicTakeNonTake={
                          this.props.deleteTopicTakeNonTake
                        }
                        saveTags={this.props.saveTags}
                        updateTopicTake={this.props.updateTopicTake}
                        currentUser={this.props.currentUser}
                        shareMeetingTopic={this.props.shareMeetingTopic}
                        deleteTopicAttach={this.props.deleteTopicAttach}
                        addTopicAttach={this.props.addTopicAttach}
                        userPermission={this.props.userPermission}
                        mtS3Data={this.props.mtS3Data}
                        actions={this.props.actions}
                        disableHoverStick={this.disableHoverStick}
                        editTopicDescEdit={this.state.editTopicDescEdit}
                        isNoAttachmentDownload={
                          this.props.isNoAttachmentDownload
                        }
                        displayKrConfidence={this.props.displayKrConfidence}
                        accessToken={this.props.accessToken}
                        appInID={this.props.appInID}
                        isFUSEnabled={this.props.isFUSEnabled}
                        updateTopicAttach={this.props.updateTopicAttach}
                      />
                    </div>
                  </div>
                </div>
                <div className="takeawayHead displayCell ">
                  <div className="firstDivTakeaways">
                    <div
                      className="wb-table meeting_take_sortable "
                      data-mid={meetingId}
                      data-type="take"
                    >
                      {this.showBox(item)}
                      {typeof item.topic_take !== "undefined" &&
                        item.topic_take.length > 0 ? (
                        <ListTakeawaysNotes
                          takeSmartWoboId={takeSmartWoboId}
                          meetingObj={meeting}
                          takeaway={item.topic_take}
                          topicId={item.id}
                          topicAiID={item.ai_id}
                          topicFname={item.firstname}
                          deleteTopicTakeNonTake={
                            this.props.deleteTopicTakeNonTake
                          }
                          saveTags={this.props.saveTags}
                          saveTakeawayAsAi={this.props.saveTakeawayAsAi}
                          updateTopicTake={this.props.updateTopicTake}
                          editTopicArea={this.props.editTopicArea}
                          saveMeetingTakeAway={this.props.saveMeetingTakeAway}
                          refreshLegacyData={this.props.refreshLegacyData}
                          canEdit={item.canEdit}
                          canDelete={item.canDelete}
                          currentUser={this.props.currentUser}
                          userPermission={this.props.userPermission}
                          sortTakeNotes={sortTakeNotes}
                          mentionsUserData={this.props.mentionsUserData}
                          topicList={item}
                          deleteNoteAttach={this.props.deleteNoteAttach}
                          addNoteAttach={this.props.addNoteAttach}
                          topicDesc={item.description}
                          mtS3Data={this.props.mtS3Data}
                          actions={this.props.actions}
                          topicToDiscuss={item.topic_to_discuss}
                          woboItemType={item.wobo_type}
                          aiid={item.ai_id}
                          isNoAttachmentDownload={
                            this.props.isNoAttachmentDownload
                          }
                          markTakeawayIgnored={
                            this.props.actions.markTakeawayIgnored
                          }
                          inlineDialogCurrentlyOpen={
                            this.props.inlineDialogCurrentlyOpen
                          }
                          meeting_takes={this.props.meeting_takes}
                          resetMeetingTakesForSmartWobo={
                            this.props.resetMeetingTakesForSmartWobo
                          }
                          accessToken={this.props.accessToken}
                          appInID={this.props.appInID}
                          isFUSEnabled={this.props.isFUSEnabled}
                          updateNoteAttach={this.props.updateNoteAttach}
                          deleteTopicAttach={this.props.deleteTopicAttach}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )
          )
          : ""}
        {divEnabled && (
          <div className="infoMeetingDetails displayTable">
            <div
              className="topicHead displayCell"
              style={{
                height: "250px",
                backgroundColor: color,
                borderRight: "5px solid #ECEFF1"
              }}
            />
            <div
              className="takeawayHead displayCell"
              style={{ width: "59%", height: "250px", backgroundColor: color }}
            />
          </div>
        )}
      </section>
    );
  }
}
export default ListTopicDetails;
